import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  formatAmount,
  HandlePurchaseRequestStatus,
  printData,
} from "../../../utility/CommonFunctions";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";

import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import CreateVoucherModal from "../Voucher/CreateVoucherModal";
import AddTdsModal from "./AddTdsModal";
import AlertModal from "./AlertModel";
import AddInvoiceDocumentModal from "./AddInvoiceDocumentModal";
import MarkAsInProgressModal from "./MarkAsInProgressModal";

import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";

export default function PaymentTicketDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [dataLoading, setDataLoading] = useState(true);
  const [state, setState] = useState({
    paymentTicketData: {},
    siteBudget: [],
    loading: false,
    IncreaseLoading: false,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    VoucherList: [],
    siteList: [],
    searchQuery: "",
    sortByDate: "",
    year: "",
    siteId: "",
    downloadLoading: false,
    taxableAmount: "",
    markAsInprogressLoading: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState({
    viewDocModal: false,
    approveRejectModal: false,
    createVoucherModel: false,
    invoiceDocModal: false,
    markAsInProgressModal: false,
  });
  const [showTdsModal, setShowTdsModal] = useState(false);
  const toggleAddTdsModal = (taxableAmount) => {
    setShowTdsModal(!showTdsModal);
  };
  const [alertModal, setAlertModal] = useState(false);
  const toggleAlertModal = () => {
    setAlertModal(!alertModal);
  };
  const toggle = (type) => {
    printData(type);
    setModal((prevModal) => ({
      ...prevModal,
      viewDocModal:
        type === "view" ? !prevModal.viewDocModal : prevModal.viewDocModal,
      approveRejectModal:
        type === "approveReject"
          ? !prevModal.approveRejectModal
          : prevModal.approveRejectModal,
      createVoucherModel:
        type === "voucher"
          ? !prevModal.createVoucherModel
          : prevModal.createVoucherModel,
      invoiceDocModal:
        type === "invoiceDoc"
          ? !prevModal.invoiceDocModal
          : prevModal.invoiceDocModal,
      markAsInProgressModal:
        type === "markAsInProgress"
          ? !prevModal.markAsInProgressModal
          : prevModal.markAsInProgressModal,
    }));
  };

  useEffect(() => {
    GetPaymentTicketDetail();
  }, []);

  const GetPaymentTicketDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_payment_ticket_details + `paymentTicketId=${id}`;
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setState((pre) => ({
          ...pre,
          paymentTicketData: response?.data,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  useEffect(() => {
    GetVoucherList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  useEffect(() => {
    const expenseHeads = state?.paymentTicketData?.paymentticketexpenseheads;

    if (Array.isArray(expenseHeads) && expenseHeads.length > 0) {
      let totalTaxableAmount = 0;

      expenseHeads.forEach((exHead) => {
        exHead?.paymentticketitems?.forEach((item) => {
          const quantity = parseFloat(item?.quantity || 0);
          const rate = parseFloat(item?.rate || 0);
          const itemAmount = quantity * rate;
          totalTaxableAmount += itemAmount;
        });
      });

      setPageStates((prev) => ({
        ...prev,
        taxableAmount: totalTaxableAmount,
      }));
    }
  }, [state?.paymentTicketData]);

  const GetVoucherList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_voucher +
      MainFilterHandler(pageStates) +
      `&paymentTicketId=${id}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.voucher?.map((item) => ({
          ...item,
          recieverName:
            item?.Transactions?.[0]?.referenceName ||
            item?.Transactions?.[0]?.accountHolderName,
          paymentTicketType: item?.paymentticket?.type,
          transDate: item?.Transactions?.[0]?.transactionDate
            ? moment(item?.Transactions?.[0]?.transactionDate).format(
              "DD-MM-YYYY"
            )
            : "--",
          ptNumber: item?.paymentticket?.ticketNumber,
          siteName: item?.paymentticket?.site?.name,
          amount: formatAmount(item?.Transactions?.[0]?.amount),
          createdBy: item?.Transactions?.[0]?.user?.name,
          paymentMethods: item?.Transactions?.[0]?.paymentMethod,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          VoucherList: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggle("view");
  };

  const handleReqStatus = (status, reason = "") => {
    setIsLoading(true);

    let postData = {
      status: status,
      ...(status === "Rejected" && { rejectReason: reason }),
      ...(status === "Hold" && { holdReason: reason, reason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    callApi(
      apiUrl.update_payment_ticket_status + `?paymentTicketId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetPaymentTicketDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle("approveReject");
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleView = (data) => {
    navigate(RoutesLink.voucher_detail + `/${data?.id}`);
  };

  const TableHeading = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "ptNumber", label: "PT NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteName", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketType", label: "Type" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];

  const HandleDownloadPA = async (data) => {
    const submitData = {
      voucherId: [data?.id],
    };
    let options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.generate_payment_advisory;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, options);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Payment Advisory.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const ActionData = [
    ...(state?.paymentTicketData?.canDownloadPA
      ? [
        {
          label: "download",
          className: "btn btn-link",
          icon: <DownloadIcon />,
          disabled: pageStates?.downloadLoading,
          title: "download",
          clickHandler: HandleDownloadPA,
        },
      ]
      : []),

    ...(state?.paymentTicketData?.canViewPA
      ? [
        {
          label: "view",
          className: "btn btn-link",
          icon: <ViewIcon />,
          title: "view",
          clickHandler: HandleView,
        },
      ]
      : []),
  ];

  const handleMarkAsInprogress = (e) => {
    if (e) e.preventDefault();
    setPageStates((pre) => ({
      ...pre,
      markAsInprogressLoading: true,
    }));
    let options = {
      method: "POST",
    };
    let API = apiUrl.update_only_payment_status + `?paymentTicketId=${id}`;
    callApi(API, options).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        markAsInprogressLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        GetPaymentTicketDetail();
      } else {
        toast.error(response?.message);
      }
    });
  };

  // Condition checks faithful to original logic
  const canChangeStatus = Boolean(
    !dataLoading &&
    (state?.paymentTicketData?.canChangeStatus ||
      state?.paymentTicketData?.status?.includes("Hold"))
  );

  const canHold = Boolean(
    canChangeStatus && !state?.paymentTicketData?.status?.includes("Hold")
  );

  const canCreateVoucher = Boolean(
    state?.paymentTicketData?.canCreateVoucher &&
    userDetails?.designation?.canCreate?.includes("voucher")
  );

  const canToggleProgress = Boolean(
    canCreateVoucher &&
    (state?.paymentTicketData?.status === "Finance Approved" ||
      state?.paymentTicketData?.status === "Director Approved") &&
    (state?.paymentTicketData?.paymentStatus === "pending" ||
      state?.paymentTicketData?.paymentStatus === "In Progress")
  );

  const hasAnyAction = canChangeStatus || canCreateVoucher;

  const totalItemsCount =
    state?.paymentTicketData?.paymentticketexpenseheads?.reduce(
      (sum, head) => sum + (head?.paymentticketitems?.length || 0),
      0
    ) || 0;

  // Primary Beneficiary Data
  const primaryBeneficiaryName =
    state.paymentTicketData?.beneficiaryName ||
    state.paymentTicketData?.vendor?.name ||
    state.paymentTicketData?.purchase?.vendor?.name ||
    state?.paymentTicketData?.receipientUser?.name ||
    "--";

  const beneficiaryFirm =
    state.paymentTicketData?.purchase?.vendor?.firmName || "--";

  const beneficiaryPhone =
    state.paymentTicketData?.phone ||
    state.paymentTicketData?.vendor?.phone ||
    state.paymentTicketData?.purchase?.vendor?.phone ||
    state?.paymentTicketData?.receipientUser?.phone ||
    "--";

  const beneficiaryBankName =
    state?.paymentTicketData?.bankName ||
    state?.paymentTicketData?.vendor?.bankName ||
    state.paymentTicketData?.purchase?.vendor?.bankName ||
    state?.paymentTicketData?.receipientUser?.userdetail?.bankName ||
    "--";

  const beneficiaryAccountHolder =
    state.paymentTicketData?.accountHolderName ||
    state.paymentTicketData?.vendor?.accountHolderName ||
    state.paymentTicketData?.purchase?.vendor?.accountHolderName ||
    state?.paymentTicketData?.receipientUser?.userdetail?.accountHolderName ||
    "--";

  const beneficiaryAccountNumber =
    state.paymentTicketData?.accountNumber ||
    state.paymentTicketData?.vendor?.accountNumber ||
    state.paymentTicketData?.purchase?.vendor?.accountNumber ||
    state?.paymentTicketData?.receipientUser?.userdetail?.accountNumber ||
    "--";

  const beneficiaryIfsc =
    state.paymentTicketData?.ifscCode ||
    state.paymentTicketData?.vendor?.ifscCode ||
    state.paymentTicketData?.purchase?.vendor?.ifscCode ||
    state?.paymentTicketData?.receipientUser?.userdetail?.ifscCode ||
    "--";

  const beneficiaryBranch =
    state.paymentTicketData?.branchName ||
    state.paymentTicketData?.branchAddress ||
    state.paymentTicketData?.vendor?.branchName ||
    state.paymentTicketData?.purchase?.vendor?.branchName ||
    state?.paymentTicketData?.receipientUser?.userdetail?.branchAddress ||
    "--";

  const renderActionButtons = (size = "md") => {
    const isSmall = size === "sm";
    const btnClass = isSmall ? "btn btn-sm" : "btn";

    return (
      <div className="d-flex align-items-center flex-wrap gap-2">
        {/* Reject Button */}
        {canChangeStatus && (
          <button
            onClick={() => {
              setModalType("reject");
              toggle("approveReject");
            }}
            className={`${btnClass} btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Reject Payment Ticket"
          >
            <CrossIcon width="12" height="12" />
            <span>Reject</span>
          </button>
        )}

        {/* Hold Button */}
        {canHold && (
          <button
            onClick={() => {
              setModalType("hold");
              toggle("approveReject");
            }}
            className={`${btnClass} btn-outline-warning d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2`}
            type="button"
            title="Put Payment Ticket on Hold"
          >
            <span>⏸</span>
            <span>Hold</span>
          </button>
        )}

        {/* Approve Button */}
        {canChangeStatus && (
          <button
            onClick={() => {
              setModalType("approve");
              toggle("approveReject");
            }}
            className={`${btnClass} btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-3.5 py-2 text-white shadow-sm`}
            style={{ background: "#059669", borderColor: "#059669" }}
            type="button"
            title="Approve Payment Ticket"
          >
            <CheckIcon />
            <span>Approve</span>
          </button>
        )}

        {/* Mark as In Progress / Mark as Pending Button */}
        {canToggleProgress && (
          <button
            className={`${btnClass} btn-outline-primary d-inline-flex align-items-center gap-2 fw-semibold px-3.5 py-2`}
            type="button"
            disabled={pageStates?.markAsInprogressLoading}
            onClick={() => toggle("markAsInProgress")}
            title={
              state?.paymentTicketData?.paymentStatus === "pending"
                ? "Mark as In Progress"
                : "Mark as Pending"
            }
          >
            {pageStates?.markAsInprogressLoading ? (
              <Spinner size="sm" />
            ) : (
              <>
                <span>🔄</span>
                <span>
                  {state?.paymentTicketData?.paymentStatus === "pending"
                    ? "Mark as inprogress"
                    : "Mark as pending"}
                </span>
              </>
            )}
          </button>
        )}

        {/* Create Payment Advisory Button */}
        {canCreateVoucher && (
          <button
            onClick={() => {
              if (
                state?.paymentTicketData?.canInsertTDS &&
                state?.paymentTicketData?.type !== "Reimbursement"
              ) {
                toggleAlertModal();
              } else {
                toggle("voucher");
              }
            }}
            className={`${btnClass} btn-primary d-inline-flex align-items-center gap-2 fw-semibold px-4 py-2 shadow-sm text-white`}
            style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
            type="button"
            title="Create Payment Advisory"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
            <span>Create Payment Advisory</span>
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      {dataLoading && <BgBlurLoader />}
      {pageStates?.downloadLoading && <BgBlurLoader />}

      <div className="content container-fluid pb-5">
        {/* Main Header with Top Action Cluster */}
        <MainHeading title="Payment Ticket Details" showBackButton={true}>
        </MainHeading>

        {/* Hold Alert Notice Banner */}
        {(state?.paymentTicketData?.status?.includes("Hold") ||
          state?.paymentTicketData?.holdReason) && (
            <div
              className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
              style={{
                background: "#fffbeb",
                borderLeft: "4px solid #f59e0b",
              }}
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  background: "#fef3c7",
                  color: "#b45309",
                  width: "36px",
                  height: "36px",
                  fontSize: "14px",
                }}
              >
                ⏸
              </div>
              <div className="flex-grow-1">
                <div
                  className="fw-bold text-dark mb-1"
                  style={{ fontSize: "14px" }}
                >
                  Payment Ticket is currently on Hold
                </div>
                <div style={{ color: "#78350f", fontSize: "13px" }}>
                  <strong>Reason: </strong>
                  {state?.paymentTicketData?.holdReason ||
                    "This payment ticket is currently placed on hold pending review."}
                </div>
              </div>
              <span
                className="badge rounded-pill px-3 py-1 flex-shrink-0"
                style={{
                  background: "#fde68a",
                  color: "#92400e",
                  fontWeight: 600,
                }}
              >
                {state?.paymentTicketData?.status}
              </span>
            </div>
          )}

        {/* Rejected Alert Notice Banner */}
        {state?.paymentTicketData?.rejectReason && (
          <div
            className="alert border-0 rounded-3 p-3 mb-4 d-flex align-items-start gap-3 shadow-sm"
            style={{
              background: "#fef2f2",
              borderLeft: "4px solid #ef4444",
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "36px",
                height: "36px",
                fontSize: "14px",
              }}
            >
              ✕
            </div>
            <div className="flex-grow-1">
              <div
                className="fw-bold text-dark mb-1"
                style={{ fontSize: "14px" }}
              >
                Payment Ticket Rejected
              </div>
              <div style={{ color: "#991b1b", fontSize: "13px" }}>
                <strong>Reason: </strong>
                {state?.paymentTicketData?.rejectReason}
              </div>
            </div>
            <span
              className="badge rounded-pill px-3 py-1 flex-shrink-0"
              style={{
                background: "#fecdd3",
                color: "#9f1239",
                fontWeight: 600,
              }}
            >
              {state?.paymentTicketData?.status}
            </span>
          </div>
        )}


        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    width: "48px",
                    height: "48px",
                    fontSize: "20px",
                  }}
                >
                  🧾
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {state?.paymentTicketData?.ticketNumber || "--"}
                    </h3>
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: "12px",
                        background:
                          state?.paymentTicketData?.type === "AgainstPO"
                            ? "#eff6ff"
                            : state?.paymentTicketData?.type === "Reimbursement"
                              ? "#fdf2f8"
                              : "#f1f5f9",
                        color:
                          state?.paymentTicketData?.type === "AgainstPO"
                            ? "#1d4ed8"
                            : state?.paymentTicketData?.type === "Reimbursement"
                              ? "#be185d"
                              : "#334155",
                        border: `1px solid ${state?.paymentTicketData?.type === "AgainstPO"
                          ? "#bfdbfe"
                          : state?.paymentTicketData?.type === "Reimbursement"
                            ? "#fbcfe8"
                            : "#e2e8f0"
                          }`,
                      }}
                    >
                      <span>
                        {state?.paymentTicketData?.type === "AgainstPO"
                          ? "📦"
                          : state?.paymentTicketData?.type === "Reimbursement"
                            ? "💸"
                            : "🧾"}
                      </span>
                      <span>{state?.paymentTicketData?.type || "General"}</span>
                    </span>
                    <div>
                      {HandlePurchaseRequestStatus(
                        state?.paymentTicketData?.status
                      )}
                    </div>
                  </div>
                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        <strong>Site:</strong>{" "}
                        {state?.paymentTicketData?.site?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Date:</strong>{" "}
                        {state?.paymentTicketData?.date
                          ? moment(state?.paymentTicketData?.date).format(
                            "DD-MM-YYYY"
                          )
                          : "--"}
                      </span>
                    </span>
                    {state?.paymentTicketData?.type === "AgainstPO" &&
                      state?.paymentTicketData?.purchase?.purchaseNumber && (
                        <>
                          <span>•</span>
                          <span className="d-inline-flex align-items-center gap-1">
                            <span>📄</span>
                            <span>
                              <strong>PO:</strong>{" "}
                              {
                                state?.paymentTicketData?.purchase
                                  ?.purchaseNumber
                              }
                            </span>
                          </span>
                        </>
                      )}
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(state?.paymentTicketData?.totalAmount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "110px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Remaining Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(state?.paymentTicketData?.remainingAmount) ||
                      "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "85px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Items
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalItemsCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={state?.paymentTicketData?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.paymentTicketData?.site?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Project / O&M Site
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Financial Year
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.paymentTicketData?.financialYear || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Expense Month:{" "}
                    {state?.paymentTicketData?.expenseMonth
                      ? moment(
                        state.paymentTicketData.expenseMonth,
                        "YYYY-MM"
                      ).format("MM/YYYY")
                      : "--"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GST Type
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.paymentTicketData?.gstType || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Specification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={state?.paymentTicketData?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {state?.paymentTicketData?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {state?.paymentTicketData?.user?.designation?.name ||
                      "Ticket Author"}
                  </div>
                </div>
              </div>

              {state?.paymentTicketData?.type === "AgainstPO" && (
                <>
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        PO Number
                      </div>
                      <div
                        className="fw-semibold text-dark"
                        style={{ fontSize: "13.5px" }}
                      >
                        {state?.paymentTicketData?.purchase?.purchaseNumber ||
                          "--"}
                      </div>
                      <div
                        className="text-secondary small mt-0.5"
                        style={{ fontSize: "11px" }}
                      >
                        Linked Purchase Order
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Payment Term
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        title={state?.paymentTicketData?.purchase?.paymentTerms}
                        style={{ fontSize: "13.5px" }}
                      >
                        {state?.paymentTicketData?.purchase?.paymentTerms ||
                          "--"}
                      </div>
                      <div
                        className="text-secondary small mt-0.5"
                        style={{ fontSize: "11px" }}
                      >
                        PO Agreed Terms
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Beneficiary Details Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span style={{ fontSize: "16px" }}>🏦</span>
              </div>
              <div>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Beneficiary Details
                </h5>
              </div>
            </div>
          </div>
          <div className="card-body p-4">
            <div className="row g-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Beneficiary Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={primaryBeneficiaryName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {primaryBeneficiaryName}
                  </div>
                </div>
              </div>

              {state?.paymentTicketData?.type === "AgainstPO" && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div
                    className="p-3 rounded-2 h-100"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #f1f5f9",
                    }}
                  >
                    <div
                      className="text-muted text-uppercase mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.05em",
                      }}
                    >
                      Beneficiary Firm
                    </div>
                    <div
                      className="fw-semibold text-dark text-truncate"
                      title={beneficiaryFirm}
                      style={{ fontSize: "13.5px" }}
                    >
                      {beneficiaryFirm}
                    </div>
                  </div>
                </div>
              )}

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Mobile No.
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryPhone}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Bank Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={beneficiaryBankName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryBankName}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Account Holder Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={beneficiaryAccountHolder}
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryAccountHolder}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Account No.
                  </div>
                  <div
                    className="fw-semibold text-dark font-monospace"
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryAccountNumber}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    IFSC Code
                  </div>
                  <div
                    className="fw-semibold text-dark font-monospace"
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryIfsc}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Branch Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={beneficiaryBranch}
                    style={{ fontSize: "13.5px" }}
                  >
                    {beneficiaryBranch}
                  </div>
                </div>
              </div>
            </div>

            {/* Current Beneficiary Details in System (if present) */}
            {state?.paymentTicketData?.receipientUser && (
              <div
                className="mt-4 pt-3 border-top"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2 mb-3">
                  <span
                    className="badge rounded-pill px-2.5 py-1 fw-semibold"
                    style={{
                      background: "#f0fdf4",
                      color: "#166534",
                      border: "1px solid #bbf7d0",
                      fontSize: "11px",
                    }}
                  >
                    System Record
                  </span>
                  <h6
                    className="mb-0 fw-bold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    Current Beneficiary Details in System
                  </h6>
                </div>
                <div className="row g-3">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Beneficiary Name
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        title={
                          state?.paymentTicketData?.receipientUser?.name
                        }
                        style={{ fontSize: "13.5px" }}
                      >
                        {state?.paymentTicketData?.receipientUser?.name || "--"}
                      </div>
                    </div>
                  </div>

                  {state?.paymentTicketData?.type === "AgainstPO" && (
                    <div className="col-12 col-sm-6 col-lg-3">
                      <div
                        className="p-3 rounded-2 h-100"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #f1f5f9",
                        }}
                      >
                        <div
                          className="text-muted text-uppercase mb-1"
                          style={{
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.05em",
                          }}
                        >
                          Beneficiary Firm
                        </div>
                        <div
                          className="fw-semibold text-dark text-truncate"
                          title={beneficiaryFirm}
                          style={{ fontSize: "13.5px" }}
                        >
                          {beneficiaryFirm}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Mobile No.
                      </div>
                      <div
                        className="fw-semibold text-dark"
                        style={{ fontSize: "13.5px" }}
                      >
                        {state.paymentTicketData?.receipientUser?.phone || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Bank Name
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        title={
                          state?.paymentTicketData?.receipientUser?.userdetail
                            ?.bankName
                        }
                        style={{ fontSize: "13.5px" }}
                      >
                        {state?.paymentTicketData?.receipientUser?.userdetail
                          ?.bankName || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Account Holder Name
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        title={
                          state.paymentTicketData?.receipientUser?.userdetail
                            ?.accountHolderName
                        }
                        style={{ fontSize: "13.5px" }}
                      >
                        {state.paymentTicketData?.receipientUser?.userdetail
                          ?.accountHolderName || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Account No.
                      </div>
                      <div
                        className="fw-semibold text-dark font-monospace"
                        style={{ fontSize: "13.5px" }}
                      >
                        {state.paymentTicketData?.receipientUser?.userdetail
                          ?.accountNumber || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        IFSC Code
                      </div>
                      <div
                        className="fw-semibold text-dark font-monospace"
                        style={{ fontSize: "13.5px" }}
                      >
                        {state.paymentTicketData?.receipientUser?.userdetail
                          ?.ifscCode || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div
                      className="p-3 rounded-2 h-100"
                      style={{
                        background: "#f8fafc",
                        border: "1px solid #f1f5f9",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-1"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          letterSpacing: "0.05em",
                        }}
                      >
                        Branch Name
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        title={
                          state.paymentTicketData?.receipientUser?.userdetail
                            ?.branchAddress
                        }
                        style={{ fontSize: "13.5px" }}
                      >
                        {state.paymentTicketData?.receipientUser?.userdetail
                          ?.branchAddress || "--"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Item Details Tables grouped by Expense Head */}
        {state?.paymentTicketData?.paymentticketexpenseheads &&
          state?.paymentTicketData?.paymentticketexpenseheads?.length > 0 ? (
          state.paymentTicketData.paymentticketexpenseheads.map(
            (exHead, index) => {
              let totalAmount = 0;
              let totalAmountWithGST = 0;
              const isAgainstPO = state?.paymentTicketData?.type === "AgainstPO";

              return (
                <div
                  className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
                  key={exHead.id || index}
                  style={{ background: "#ffffff" }}
                >
                  <div
                    className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                    style={{ borderColor: "#f1f5f9" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                        style={{ background: "#f1f5f9", color: "#475569" }}
                      >
                        <span
                          style={{
                            fontSize: "15px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: 1,
                            transform: "translateY(-1.5px)",
                          }}
                        >
                          🏷️
                        </span>
                      </div>
                      <div>
                        <div
                          className="text-muted text-uppercase"
                          style={{
                            fontSize: "10.5px",
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                          }}
                        >
                          Expense Head
                        </div>
                        <h5
                          className="mb-0 fw-bold text-dark"
                          style={{ fontSize: "15px" }}
                        >
                          {exHead?.expensehead?.name || "--"}
                        </h5>
                      </div>
                    </div>
                    <span
                      className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                      style={{ fontSize: "12px", fontWeight: 600 }}
                    >
                      {exHead?.paymentticketitems?.length || 0}{" "}
                      {exHead?.paymentticketitems?.length === 1
                        ? "Line Item"
                        : "Line Items"}
                    </span>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table pr-detail-table align-middle mb-0"
                      style={{ borderCollapse: "separate", borderSpacing: "0" }}
                    >
                      <thead style={{ background: "#f8fafc" }}>
                        <tr>
                          <th
                            style={{
                              width: "50px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            #
                          </th>
                          <th
                            style={{
                              minWidth: "200px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Item
                          </th>
                          {isAgainstPO && (
                            <th
                              style={{
                                width: "120px",
                                padding: "12px 16px",
                                fontSize: "11px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                color: "#64748b",
                              }}
                            >
                              HSN Code
                            </th>
                          )}
                          <th
                            style={{
                              width: "120px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Quantity
                          </th>
                          <th
                            className="text-end"
                            style={{
                              width: "120px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Rate
                          </th>
                          <th
                            className="text-end"
                            style={{
                              width: "130px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Amount
                          </th>
                          {state?.paymentTicketData?.gstType === "IGST" && (
                            <th
                              className="text-end"
                              style={{
                                width: "140px",
                                padding: "12px 16px",
                                fontSize: "11px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                color: "#64748b",
                              }}
                            >
                              IGST
                            </th>
                          )}
                          {state?.paymentTicketData?.gstType ===
                            "CGST + SGST" && (
                              <>
                                <th
                                  className="text-end"
                                  style={{
                                    width: "130px",
                                    padding: "12px 16px",
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    textTransform: "uppercase",
                                    letterSpacing: "0.05em",
                                    color: "#64748b",
                                  }}
                                >
                                  CGST
                                </th>
                                <th
                                  className="text-end"
                                  style={{
                                    width: "130px",
                                    padding: "12px 16px",
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    textTransform: "uppercase",
                                    letterSpacing: "0.05em",
                                    color: "#64748b",
                                  }}
                                >
                                  SGST
                                </th>
                              </>
                            )}
                          <th
                            className="text-end"
                            style={{
                              width: "160px",
                              padding: "12px 16px",
                              fontSize: "11px",
                              fontWeight: 700,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              color: "#64748b",
                            }}
                          >
                            Amount With GST
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {exHead?.paymentticketitems?.length > 0 ? (
                          exHead.paymentticketitems.map((item, i) => {
                            const amount =
                              parseFloat(item?.quantity || 0) *
                              parseFloat(item?.rate || 0);
                            const gstAmount =
                              (amount * parseFloat(item?.gst || 0)) / 100;

                            totalAmount += amount;
                            totalAmountWithGST += gstAmount;

                            return (
                              <tr
                                key={i}
                                style={{ borderBottom: "1px solid #f1f5f9" }}
                              >
                                <td
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13px",
                                    color: "#94a3b8",
                                    fontWeight: 600,
                                  }}
                                >
                                  {i + 1}
                                </td>
                                <td style={{ padding: "14px 16px" }}>
                                  <div
                                    className="fw-semibold text-dark"
                                    style={{ fontSize: "13.5px" }}
                                  >
                                    {item?.item?.name || "--"}
                                  </div>
                                </td>
                                {isAgainstPO && (
                                  <td
                                    style={{
                                      padding: "14px 16px",
                                      fontSize: "13px",
                                      color: "#475569",
                                    }}
                                  >
                                    {item?.item?.hsnCode || "--"}
                                  </td>
                                )}
                                <td style={{ padding: "14px 16px" }}>
                                  <span className="fw-medium text-dark">
                                    {item?.quantity}
                                  </span>{" "}
                                  <span
                                    className="badge rounded-pill bg-light text-secondary border px-2 py-0.5"
                                    style={{ fontSize: "11.5px" }}
                                  >
                                    {item?.item?.unit || "--"}
                                  </span>
                                </td>
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#475569",
                                    fontWeight: 500,
                                  }}
                                >
                                  {formatAmount(item?.rate)}
                                </td>
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#475569",
                                    fontWeight: 500,
                                  }}
                                >
                                  {formatAmount(item?.rate * item?.quantity)}
                                </td>
                                {state?.paymentTicketData?.gstType ===
                                  "IGST" && (
                                    <td
                                      className="text-end"
                                      style={{
                                        padding: "14px 16px",
                                        fontSize: "13px",
                                        color: "#475569",
                                      }}
                                    >
                                      <div>
                                        {formatAmount(
                                          (item?.quantity *
                                            item?.rate *
                                            item?.gst) /
                                          100
                                        )}
                                      </div>
                                      <div
                                        className="text-muted"
                                        style={{ fontSize: "11px" }}
                                      >
                                        ({item?.gst || 0}%)
                                      </div>
                                    </td>
                                  )}
                                {state?.paymentTicketData?.gstType ===
                                  "CGST + SGST" && (
                                    <>
                                      <td
                                        className="text-end"
                                        style={{
                                          padding: "14px 16px",
                                          fontSize: "13px",
                                          color: "#475569",
                                        }}
                                      >
                                        <div>
                                          {formatAmount(
                                            (item?.quantity *
                                              item?.rate *
                                              item?.gst) /
                                            2 /
                                            100
                                          )}
                                        </div>
                                        <div
                                          className="text-muted"
                                          style={{ fontSize: "11px" }}
                                        >
                                          ({item?.gst / 2 || 0}%)
                                        </div>
                                      </td>
                                      <td
                                        className="text-end"
                                        style={{
                                          padding: "14px 16px",
                                          fontSize: "13px",
                                          color: "#475569",
                                        }}
                                      >
                                        <div>
                                          {formatAmount(
                                            (item?.quantity *
                                              item?.rate *
                                              item?.gst) /
                                            2 /
                                            100
                                          )}
                                        </div>
                                        <div
                                          className="text-muted"
                                          style={{ fontSize: "11px" }}
                                        >
                                          ({item?.gst / 2 || 0}%)
                                        </div>
                                      </td>
                                    </>
                                  )}
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "14px 16px",
                                    fontSize: "13.5px",
                                    color: "#0f172a",
                                    fontWeight: 700,
                                  }}
                                >
                                  {formatAmount(item?.taxableAmount)}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                isAgainstPO
                                  ? state?.paymentTicketData?.gstType ===
                                    "CGST + SGST"
                                    ? 9
                                    : 8
                                  : state?.paymentTicketData?.gstType ===
                                    "CGST + SGST"
                                    ? 8
                                    : 7
                              }
                              className="text-center py-4 text-muted small fw-bold"
                            >
                              No Line Items Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot
                        style={{
                          background: "#f8fafc",
                          borderTop: "2px solid #e2e8f0",
                        }}
                      >
                        <tr className="fw-bold">
                          <td
                            style={{
                              padding: "12px 16px",
                              fontSize: "13px",
                              color: "#0f172a",
                            }}
                          >
                            Total
                          </td>
                          <td></td>
                          {isAgainstPO && <td></td>}
                          <td></td>
                          <td></td>
                          <td
                            className="text-end"
                            style={{
                              padding: "12px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                            }}
                          >
                            {formatAmount(totalAmount)}
                          </td>
                          {state?.paymentTicketData?.gstType === "IGST" && (
                            <td
                              className="text-end"
                              style={{
                                padding: "12px 16px",
                                fontSize: "13.5px",
                                color: "#0f172a",
                              }}
                            >
                              {formatAmount(totalAmountWithGST)}
                            </td>
                          )}
                          {state?.paymentTicketData?.gstType ===
                            "CGST + SGST" && (
                              <>
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "12px 16px",
                                    fontSize: "13.5px",
                                    color: "#0f172a",
                                  }}
                                >
                                  {formatAmount(totalAmountWithGST / 2)}
                                </td>
                                <td
                                  className="text-end"
                                  style={{
                                    padding: "12px 16px",
                                    fontSize: "13.5px",
                                    color: "#0f172a",
                                  }}
                                >
                                  {formatAmount(totalAmountWithGST / 2)}
                                </td>
                              </>
                            )}
                          <td
                            className="text-end"
                            style={{
                              padding: "12px 16px",
                              fontSize: "13.5px",
                              color: "#0f172a",
                              fontWeight: 700,
                            }}
                          >
                            {formatAmount(exHead?.taxableAmount)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              );
            }
          )
        ) : (
          <div className="card border-0 shadow-sm rounded-3 p-5 text-center bg-white mb-4">
            <span style={{ fontSize: "2rem" }}>📦</span>
            <h6 className="fw-bold mt-2 text-dark">No Items Found</h6>
            <p className="text-muted small mb-0">
              This payment ticket does not contain any item details.
            </p>
          </div>
        )}

        {/* Financial Summary Card (Grand Total, TDS & Gross Amount) */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>💰</span>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Financial Summary
                </h5>
              </div>
              <div>
                <span className="text-secondary small fw-medium">
                  All amounts in INR (₹)
                </span>
              </div>
            </div>

            <div className="row justify-content-end pt-3">
              <div className="col-12 col-md-7 col-lg-5">
                <div className="d-flex flex-column gap-2.5">
                  {/* Grand Total */}
                  <div className="d-flex align-items-center justify-content-between py-1">
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      Grand Total:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "16px" }}
                    >
                      {formatAmount(state?.paymentTicketData?.totalAmount)}
                    </span>
                  </div>

                  {/* TDS Section if not Reimbursement */}
                  {state?.paymentTicketData?.type !== "Reimbursement" && (
                    <>
                      <div
                        className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                        style={{
                          background: "#f8fafc",
                          border: "1px dashed #cbd5e1",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-secondary small fw-semibold">
                            TDS ({+state?.paymentTicketData?.tdsPercentage || 0}
                            %):
                          </span>
                          {(state?.paymentTicketData?.canInsertTDS ||
                            state?.paymentTicketData?.canUpdateTDS) && (
                              <button
                                className="btn btn-xs btn-outline-primary py-0.5 px-2 rounded"
                                style={{ fontSize: "11px", fontWeight: 600 }}
                                type="button"
                                onClick={toggleAddTdsModal}
                              >
                                {state?.paymentTicketData?.canInsertTDS &&
                                  "+ Add TDS"}
                                {state?.paymentTicketData?.canUpdateTDS &&
                                  "✎ Edit TDS"}
                              </button>
                            )}
                        </div>
                        <span
                          className="fw-semibold text-danger"
                          style={{ fontSize: "14.5px" }}
                        >
                          -{" "}
                          {formatAmount(
                            +state?.paymentTicketData?.tdsAmount || 0
                          )}
                        </span>
                      </div>

                      {/* Gross Amount */}
                      <div
                        className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-1"
                        style={{
                          background: "#f0fdf4",
                          border: "1px solid #bbf7d0",
                        }}
                      >
                        <div>
                          <div
                            className="text-uppercase"
                            style={{
                              fontSize: "11px",
                              fontWeight: 700,
                              color: "#166534",
                              letterSpacing: "0.04em",
                            }}
                          >
                            Gross Payable Amount
                          </div>
                          <div
                            className="text-muted"
                            style={{ fontSize: "11.5px" }}
                          >
                            Total after TDS deductions
                          </div>
                        </div>
                        <div className="text-end">
                          <span
                            className="fw-bold"
                            style={{ fontSize: "1.35rem", color: "#15803d" }}
                          >
                            {formatAmount(
                              state?.paymentTicketData?.grossAmount
                            )}
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Advisories Section */}
        {(state?.paymentTicketData?.status?.includes("Approved") ||
          state?.paymentTicketData?.status?.includes("Completed") ||
          state?.paymentTicketData?.status?.includes("Director Created") ||
          state?.paymentTicketData?.status?.includes("Finance Created")) && (
            <div
              className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                    style={{ background: "#f1f5f9", color: "#475569" }}
                  >
                    <span style={{ fontSize: "15px" }}>💳</span>
                  </div>
                  <div>
                    <h5
                      className="mb-0 fw-bold text-dark"
                      style={{ fontSize: "15px" }}
                    >
                      Payment Advisories
                    </h5>
                  </div>
                </div>
                <span
                  className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
                  style={{ fontSize: "12px", fontWeight: 600 }}
                >
                  {pageStates?.count || 0} Advisories
                </span>
              </div>
              <div className="card-body p-3">
                <CommonTable
                  TableHeading={TableHeading}
                  TableData={pageStates?.VoucherList}
                  ActionData={ActionData}
                  currentPage={pageStates?.currentPage}
                  PageChangeHandler={PageChangeHandler}
                  isLoading={pageStates?.tableLoader}
                  totalPages={pageStates?.totalPages}
                  count={pageStates?.count}
                  handleChangePageSize={handleChangePageSize}
                  pageSize={pageStates?.pageSize}
                />
              </div>
            </div>
          )}

        {/* Missing Invoice Alert Notice Banner */}
        {state?.paymentTicketData?.isInvoice !== true && (
          <div
            className="alert border-0 rounded-3 p-1 mb-4 d-flex align-items-center justify-content-between flex-wrap gap-3 shadow-sm"
            style={{
              background: "#fffbeb",
              borderLeft: "4px solid #f59e0b",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  background: "#fef3c7",
                  color: "#b45309",
                  width: "38px",
                  height: "38px",
                  fontSize: "16px",
                }}
              >
                ⚠️
              </div>
              <div>
                <div
                  className="fw-bold text-dark mb-0.5"
                  style={{ fontSize: "14px" }}
                >
                  Invoice Document Missing
                </div>
                <div style={{ color: "#78350f", fontSize: "13px" }}>
                  Invoice document is missing for this ticket. Please upload the
                  required invoice.
                </div>
              </div>
            </div>

            <button
              className="btn btn-warning text-dark fw-semibold d-inline-flex align-items-center gap-2 px-2 py-1 shadow-sm"
              style={{ background: "#fbbf24", borderColor: "#f59e0b" }}
              type="button"
              onClick={() => toggle("invoiceDoc")}
            >
              <UploadPlusIcon width="16" height="16" />
              <span>Upload Invoice</span>
            </button>
          </div>
        )}


        {/* Description & Supporting Documents Section */}
        <div className="row g-4 mb-4">
          {/* Attached Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span
                    style={{
                      fontSize: "16px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                      transform: "translateY(-2px)",
                    }}
                  >
                    📎
                  </span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px" }}
                >
                  {state?.paymentTicketData?.documents?.length || 0} Files
                </span>
              </div>
              <div className="card-body p-4">
                {state?.paymentTicketData?.documents &&
                  state.paymentTicketData.documents.length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {state.paymentTicketData.documents.map((doc, index) => (
                      <div
                        key={doc.id || index}
                        role="button"
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between gap-3 text-decoration-none shadow-sm"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2 overflow-hidden">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              background: "#eff6ff",
                              color: "#2563eb",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <DocumentIcon />
                          </div>
                          <div className="overflow-hidden">
                            <div
                              className="text-dark fw-semibold text-truncate small"
                              title={doc?.name || "Document"}
                            >
                              {doc?.name || "Document"}
                            </div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              {doc?.updatedAt
                                ? moment(doc?.updatedAt).format(
                                  "DD MMM YYYY | h:mm a"
                                )
                                : "Attached Document"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="text-muted small py-4 text-center"
                    style={{
                      background: "#f8fafc",
                      borderRadius: "8px",
                      border: "1px dashed #cbd5e1",
                    }}
                  >
                    No Document Found
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Description Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                    transform: "translateY(-2px)",
                  }}
                >
                  📝
                </span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Description
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "100px",
                  }}
                >
                  <CKEditor
                    editor={ClassicEditor}
                    data={
                      state?.paymentTicketData?.description ||
                      "No Description..."
                    }
                    disabled={true}
                    config={{
                      toolbar: [],
                      readOnly: true,
                      image: {
                        toolbar: [
                          "imageStyle:alignLeft",
                          "imageStyle:alignCenter",
                          "imageStyle:alignRight",
                          "|",
                          "imageTextAlternative",
                        ],
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Action Bar */}
        {hasAnyAction && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-3 d-flex flex-row align-items-center justify-content-between flex-wrap gap-3"
            style={{
              background: "#ffffff",
              borderLeft: "4px solid #4f46e5",
            }}
          >
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                className="text-secondary small fw-bold text-uppercase"
                style={{ letterSpacing: "0.04em" }}
              >
                Current Status:
              </span>
              <div>
                {HandlePurchaseRequestStatus(state?.paymentTicketData?.status)}
              </div>
            </div>
            <div>{renderActionButtons("md")}</div>
          </div>
        )}

        {/* Audit Trail & Activity Logs */}
        <Logs
          type={"paymentTicket"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      {/* Modals */}
      <ApproveRejectModal
        modal={modal.approveRejectModal}
        toggle={() => toggle("approveReject")}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject"
              ? "Rejected"
              : modalType === "hold"
                ? "Hold"
                : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
      <ViewDocumentModal
        modal={modal.viewDocModal}
        toggle={() => toggle("view")}
        selectedDocument={selectedDocument}
      />
      <AddInvoiceDocumentModal
        modal={modal.invoiceDocModal}
        toggle={() => toggle("invoiceDoc")}
        modalData={state?.paymentTicketData}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
      />
      <AddTdsModal
        modal={showTdsModal}
        toggle={toggleAddTdsModal}
        modalData={state?.paymentTicketData}
        taxableAmount={pageStates?.taxableAmount}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
      />
      <CreateVoucherModal
        isOpen={modal.createVoucherModel}
        toggle={() => toggle("voucher")}
        EditData={null}
        paymentTicketDetails={state?.paymentTicketData}
        GetPaymentTicketDetail={GetPaymentTicketDetail}
        GetVoucherList={GetVoucherList}
        from="paymentTicket"
      />
      <AlertModal
        modal={alertModal}
        toggle={toggleAlertModal}
        submitHandler={() => toggle("voucher")}
      />
      <MarkAsInProgressModal
        modal={modal.markAsInProgressModal}
        toggle={() => toggle("markAsInProgress")}
        submitHandler={handleMarkAsInprogress}
        isPending={state?.paymentTicketData?.paymentStatus === "pending"}
      />
    </>
  );
}
